import { Component, OnInit } from '@angular/core';
import {AnnonceModelServiceService}from '../annoncement-model/annoncement-service/Annonce-model-service.service'
import { IAnnouncement } from '../interfaces/Iannouncement';

@Component({
  selector: 'app-annoncement-model',
  templateUrl: './annoncement-model.component.html',
  styleUrls: ['./annoncement-model.component.scss']
})
export class AnnoncementModelComponent implements OnInit {
  annonce: IAnnouncement;
  flag :boolean;
  constructor(private AnnonceModelServiceService : AnnonceModelServiceService ) { }

  ngOnInit() {
   const isFlag = sessionStorage.getItem('flag');


   
   if (isFlag) {
     this.flag = true; // hide the modal
   }else {
    //updated by true request from Customer to disable POpup

     this.flag = false; // show the modal
   }

    this.getActiveAnnoncement(null);

  }
  getActiveAnnoncement(e) {
    let params = {
      "language": localStorage.getItem('lang') == 'ar' ? localStorage.getItem('lang') + '-SA' : 'en'
    }



    this.AnnonceModelServiceService.getActiveAnnoncement('GetActiveAnnouncement', params).subscribe(response => {
      this.annonce = response.Result;
    })


  }

  changeValue(){
    sessionStorage.setItem('flag', JSON.stringify(true)); // set true
    this.flag = true; // hide the modal
  }
}




